import { render, staticRenderFns } from "./Peraltees.vue?vue&type=template&id=4a16531c&scoped=true&"
import script from "./Peraltees.vue?vue&type=script&lang=ts&"
export * from "./Peraltees.vue?vue&type=script&lang=ts&"
import style0 from "./Peraltees.vue?vue&type=style&index=0&id=4a16531c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16531c",
  null
  
)

export default component.exports